export default __webpack_public_path__ + "static/media/jscs.a5d32b08.svg";